/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/StarClub/SCCollection',[
    'lodash',
    'Managers/ChallengeManager',
    'Solitaire/StarClub/SCChallengePack'
], function (_, ChallengeManager, SCChallengePack) {
    "use strict";


    var SCCollection = function (config, icon) {
        this.initSCCollection(config, icon);
    };

    /*
     {
     "ChallengeAmount": 100,
     "CollectionGroup": {
     "CollectionGroupName": "MixedCollection",
     "CollectionPriority": 3
     },
     "WorldId": 110,
     "CompleteBonus": 0,
     "FileName": "world20130504040512.js",
     "ID": "cb9b46f9-c9d2-4bdf-a006-f44bb35fb295",
     "ImgPath": "CoralCove.png",
     "Name": "CoralCoveCollectionName",
     "PMPacks": null,
     "PackAmount": 10,
     "PriceOfUnlocking": 140,
     "SentientId": 102,
     "StarAmount": 220,
     "Theme": "aquarium"
     },

     */
    SCCollection.prototype.initSCCollection = function (config, icon) {
        this.config = config;
        this.icon = icon;
        this.images = {};

        ChallengeManager.StoreChallengePack(config);

    };

    SCCollection.prototype.setPackConfig = function (packConfig) {
        this.packConfig = packConfig;
    };

    SCCollection.prototype.buildPacks = function () {
        this.Packs = [];
        _.forEach(this.packConfig.PMPacks, function (packData) {
            var packIcon = this.images[packData.ImgPath];
            this.Packs.push(new SCChallengePack(packData, packIcon, this.Theme));
        }, this);

        this.Packs.sort(function (a, b) {
            return a.PriceOfUnlocking - b.PriceOfUnlocking;
        })
    };

    SCCollection.prototype.addImage = function (name, texture) {
        this.images[name] = texture;
    };

    Object.defineProperty(SCCollection.prototype, "Name", {
        get: function () {
            return this.config.Name;
        }
    });

    Object.defineProperty(SCCollection.prototype, "FileName", {
        get: function () {
            return this.config.FileName;
        }
    });

    Object.defineProperty(SCCollection.prototype, "Key", {
        get: function () {
            return this.config.FileName.substring(0, this.config.FileName.indexOf(".js"));
        }
    });

    Object.defineProperty(SCCollection.prototype, "CollectionGroupName", {
        get: function () {
            return this.config.CollectionGroup.CollectionGroupName;
        }
    });

    Object.defineProperty(SCCollection.prototype, "CollectionPriority", {
        get: function () {
            return this.config.CollectionGroup.CollectionPriority;
        }
    });

    Object.defineProperty(SCCollection.prototype, "ChallengePacks", {
        get: function () {
            if (!this.Packs) {
                this.buildPacks();
            }
            return this.Packs;
        }
    });

    Object.defineProperty(SCCollection.prototype, "Theme", {
        get: function () {
            return this.config.Theme;
        }
    });


    Object.defineProperty(SCCollection.prototype, "NumPacks", {
        get: function () {
            if (!this.Packs) {
                this.buildPacks();
            }
            return this.Packs.length;
        }
    });

    Object.defineProperty(SCCollection.prototype, "NumPacksCompleted", {
        get: function () {
            var packsCompleted = 0;
            _.forEach(this.Packs, function (pack) {
                var stats = pack.getPackStats();
                packsCompleted += stats.challengesCompleted == stats.totalChallenges ? 1 : 0;
            });

            return packsCompleted;
        }
    });

    Object.defineProperty(SCCollection.prototype, "NumStars", {
        get: function () {
            if (!this.Packs) {
                this.buildPacks();
            }
            var stars = 0;
            for (var p = 0; p < this.Packs.length; p++) {
                stars += this.Packs[p].NumStars;
            }
            return stars;
        }
    });

    Object.defineProperty(SCCollection.prototype, "NumStarsEarned", {
        get: function () {
            var stars = 0;
            for (var p = 0; p < this.Packs.length; p++) {
                stars += this.Packs[p].NumStarsEarned;
            }
            return stars;
        }
    });

    Object.defineProperty(SCCollection.prototype, "Unlocked", {
        get: function () {
            return this.config.PriceOfUnlocking == 0 || ChallengeManager.IsChallengeCollectionUnlocked(this.config.ID);
        },
        set: function (value) {
            ChallengeManager.SetChallengeCollectionUnlocked(this.config.ID, value);
        }
    });

    Object.defineProperty(SCCollection.prototype, "PriceOfUnlocking", {
        get: function () {

            return this.config.PriceOfUnlocking;
        }
    });

    SCCollection.prototype.getCollectionStats = function () {
        var totalStats = {
            totalStarsEarned: 0,
            challengesCompleted: 0,
            totalChallenges: 0,
            packsUnlocked: 0,
            crownsEarned: 0,
            complete: false
        };

        _.forEach(this.Packs, function (pack) {
            var stats = pack.getPackStats();
            totalStats.totalStarsEarned += stats.totalStarsEarned;
            totalStats.challengesCompleted += stats.challengesCompleted;
            totalStats.totalChallenges += stats.totalChallenges;
            totalStats.packsUnlocked += pack.PriceOfUnlocking > 0 && pack.Unlocked ? 1 : 0;
            totalStats.crownsEarned += stats.challengesCompleted == stats.totalChallenges ? 1 : 0;
        });

        totalStats.complete = this.NumPacks == this.NumPacksCompleted;

        return totalStats;
    };



    return SCCollection;

});

